// extracted by mini-css-extract-plugin
module.exports = {"general":"style_general__2HkMa","modalLeftRight":"style_modalLeftRight__S12kz","modalFade":"style_modalFade__3Cst7","cross":"style_cross__1lQCo","easyZoom":"style_easyZoom__lmVy-"};